// Single source of truth for app groups. Used by Apps/Detail (group editor)
// and CreateAppDialog (group picker).
export const GROUPS = ["sticker", "neku", "emojimaker", "backend"];

/** Bucket label for apps without a group. */
export const UNGROUPED = "Ungrouped";

/**
 * Group a list of apps by `group` with the shared ordering rule: canonical
 * GROUPS first, unknown groups after alphabetically, ungrouped last.
 * Used by the sidebar, the admin app-owners page and EditVisibleAppsDialog.
 */
export const groupAppsByGroup = <T extends { group?: string | null }>(
  apps: T[],
): [string, T[]][] => {
  const map = new Map<string, T[]>();
  for (const app of apps) {
    const key = app.group || UNGROUPED;
    const list = map.get(key);
    if (list) list.push(app);
    else map.set(key, [app]);
  }
  const rank = (name: string) => {
    if (name === UNGROUPED) return GROUPS.length + 1;
    const i = GROUPS.indexOf(name);
    return i === -1 ? GROUPS.length : i;
  };
  return [...map.entries()].sort(
    ([a], [b]) => rank(a) - rank(b) || a.localeCompare(b),
  );
};
